import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {removeSpaces} from 'src/app/Shared/directives/common-form-validator.directive';
import {validateAllFormFields} from 'src/app/Shared/utilities/helpers';
import {AuthService} from 'src/app/Shared/services/api-services/auth.service';
import {NotificationService} from 'src/app/Shared/services/app-services/notification.service';
import {CUSTOM_CONSTANTS} from 'src/app/Shared/utilities/config';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styles: []
})
export class ResetPasswordComponent implements OnInit {
  @Output() switchDom = new EventEmitter<string>();

  public state = {
    post: false
  };

  forgotPasswordForm: FormGroup;

  constructor(private _FB: FormBuilder, private _authService: AuthService, private _notificationService: NotificationService) { }

  ngOnInit() {
    return this.forgotPasswordForm = this._FB.group({
      email: ['', [Validators.required, Validators.email, removeSpaces]]
    });
  }

  public goBack(): void {
    this.switchDom.emit('LOGIN');
  }

  public submit(): void {
    if (this.forgotPasswordForm.invalid) {
      return validateAllFormFields(this.forgotPasswordForm);
    }
    this.state.post = true;
    console.log(this.forgotPasswordForm.value);
    this._authService.resetPassword({...this.forgotPasswordForm.value, baseurl: window.location.host}).subscribe(res => {
      this.state.post = false;
      console.log(res.data);
      this._notificationService.showSuccess(`${res.message}`, CUSTOM_CONSTANTS.DEFAULT_SUCCESS_MESSAGE);
      setTimeout(() => {
        this.goBack();
      }, 2000); // go back
    }, err => {
      this.state.post = false;
      this._notificationService.showError(`${err.error.message}`, err, CUSTOM_CONSTANTS.DEFAULT_ERROR_MESSAGE);
    });
  }

}
